import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import CspHeader from './components/csp-header';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <CspHeader />
    <App />
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'production') {
  // ページ読み込みなどの統計情報を表示
  reportWebVitals(console.log);

  // Deploy環境がUpdateされているかを確認するためのログ
  console.log('Commit Hash', process.env.REACT_APP_CODEBUILD_RESOLVED_SOURCE_VERSION);
}
